
import Button from '../../../components/base/Button';

export default function ProgramsHeroSection() {
  return (
    <section 
      className="relative py-20 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.8), rgba(30, 64, 175, 0.8)), url('https://public.readdy.ai/ai/img_res/f336e8e467524c52513e7cea74fede29.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Programs & Education
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
            Comprehensive programs designed to advance healthcare professionals and strengthen the bridge between pharmacy and veterinary care across Canada.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">150+</div>
              <div className="text-lg">Educational Modules</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">25+</div>
              <div className="text-lg">Monthly Events</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">500+</div>
              <div className="text-lg">CE/CPD Hours</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">98%</div>
              <div className="text-lg">Member Satisfaction</div>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-white text-blue-900 hover:bg-gray-100">
              Browse Programs
            </Button>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-blue-900">
              View Calendar
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
